module.exports = __webpack_public_path__ + "img/chart.ec595f50.png";